import {
  isExternalLinksEnabled,
  isFreeAlbum,
  isFreeTrack,
  isNameYourPrice,
  isPurchaseAvail,
  isSubscribeRequired,
} from './albumProvider';
import {ENTITY_GET_OPTIONS} from './albumProviderConstant';

export function getEntityGetOption(album, track?) {
  if (isExternalLinksEnabled(album, track)) {
    return ENTITY_GET_OPTIONS.GET;
  }
  if (!isPurchaseAvail(album, track)) {
    return ENTITY_GET_OPTIONS.NOTHING;
  }
  const isSubscribe = isSubscribeRequired(track ? track : album);
  if (isSubscribe) {
    return ENTITY_GET_OPTIONS.DOWNLOAD;
  }
  const isFree = track ? isFreeTrack(track) : isFreeAlbum(album);
  if (isFree) {
    return ENTITY_GET_OPTIONS.DOWNLOAD;
  }
  if (track && isNameYourPrice(track) && Number(track.trackPrice) === 0) {
    return ENTITY_GET_OPTIONS.DOWNLOAD;
  }
  if (!track && isNameYourPrice(album) && Number(album.albumPrice) === 0) {
    return ENTITY_GET_OPTIONS.DOWNLOAD;
  }
  return ENTITY_GET_OPTIONS.BUY;
}
